<template>
  <v-dialog v-model="dialogInsertAffiliate" max-width="700px" scrollable>
    <v-card>
      <v-col class="px-6">
        <span style="font-weight: bold; font-size: 20px"
          >{{ $t('sales.affiliates_program_manage') }}
          <span style="font-weight: normal">
            - {{ dataProgram.nome }}</span
          ></span
        >
        <v-alert
          class="mb-3 mt-3"
          border="left"
          colored-border
          type="info"
          elevation="2"
        >
          {{ $t('sales.affiliates_program_manage_info') }}
        </v-alert>
      </v-col>
      <v-card-text class="d-flex justify-center align-center">
        <v-card
          elevation="10"
          width="500"
          height="300"
          style="padding: 8px; overflow: auto; margin-right: 20px"
        >
          <v-text-field
            solo
            dense
            :placeholder="$t('sales.affiliates_program_search_placeholder')"
            v-model="searchAffiliate"
            @input="searchAffiliateByName"
          ></v-text-field>
          <v-chip
            v-for="affiliate in unselectedAffiliates"
            :key="affiliate.idafiliado"
            link
            draggable
            @click="selectedAffiliates.push(affiliate)"
            style="margin-right: 4px; margin-bottom: 4px"
            >{{ affiliate.nome || $t('sales.affiliates_program_unavailable_name') }}</v-chip
          >
        </v-card>
        <v-card
          elevation="10"
          width="500"
          height="300"
          style="padding: 8px; overflow: auto; margin-right: 20px"
        >
          <v-text-field
            solo
            dense
            :placeholder="$t('sales.affiliates_program_search_placeholder')"
            v-model="searchSelectedAffiliate"
            @input="searchSelectedAffiliateByName"
          ></v-text-field>
          <v-chip
            v-for="affiliate in searchSelectedAffiliate
              ? selectedAffiliatesOnSearch
              : selectedAffiliates"
            :key="affiliate.idafiliado"
            link
            close
            @click:close="removeSelectedAffiliate(affiliate.idafiliado)"
            style="margin-right: 4px; margin-bottom: 4px"
            >{{ affiliate.nome || $t('sales.affiliates_program_unavailable_name') }}</v-chip
          >
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :color="$config.dados.primary"
          @click="closeModal"
          class="rounded-xxl"
          outlined
          >{{ $t('sales.affiliates_program_cancel') }}</v-btn
        >
        <v-btn
          @click="handleSave"
          :color="$config.dados.primary"
          class="rounded-xxl"
          style="color: white"
          >{{ $t('sales.affiliates_program_save') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "DialogInsertAffiliate",
  data() {
    return {
      searchAffiliate: "",
      selectedAffiliates: [],
      selectedAffiliatesOnSearch: [],
      searchSelectedAffiliate: "",
    };
  },
  computed: {
    ...mapGetters([
      "allAffiliates",
      "dialogInsertAffiliate",
      "affiliatesByProgram",
      "idProgramTemp",
      "dataProgram",
    ]),
    unselectedAffiliates() {
      return this.allAffiliates.filter(
        affiliate =>
          !this.selectedAffiliates.find(
            selectedAffiliate =>
              selectedAffiliate.idafiliado === affiliate.idafiliado
          )
      );
    },
  },
  methods: {
    ...mapActions([
      "fetchAllAffiliates",
      "changeDialogInsertAffiliate",
      "changeProgramAffiliate",
      "getInfoProgram",
      "cleanStates",
      "showSnackbarSuccess",
    ]),
    searchSelectedAffiliateByName() {
      this.selectedAffiliatesOnSearch = this.selectedAffiliates.filter(
        affiliate =>
          affiliate.nome
            .toLowerCase()
            .includes(this.searchSelectedAffiliate.toLowerCase())
      );
    },

    removeSelectedAffiliate(id) {
      const index = this.selectedAffiliates.findIndex(
        affiliate => affiliate.idafiliado === id
      );
      if (index !== -1) {
        this.selectedAffiliates.splice(index, 1);
      }

      const searchIndex = this.selectedAffiliatesOnSearch.findIndex(
        affiliate => affiliate.idafiliado === id
      );
      if (searchIndex !== -1) {
        this.selectedAffiliatesOnSearch.splice(searchIndex, 1);
      }
    },

    searchAffiliateByName() {
      this.fetchAllAffiliates({
        loja: "",
        limite: 1000,
        pagina: 1,
        status: "",
        name: this.searchAffiliate,
      });
    },
    closeModal() {
      this.selectedAffiliates = [];
      this.changeDialogInsertAffiliate(this.idProgramTemp);
    },
    turnSelectedAffiliatesIntoArray() {
      this.affiliatesByProgram.forEach(affiliate => {
        this.selectedAffiliates.push(affiliate);
      });
    },
    handleSave() {
      const filter = {
        idprograma: this.idProgramTemp,
        emails: this.selectedAffiliates.map(affiliate => {
          return affiliate.email;
        }),
      };
      this.changeProgramAffiliate(filter).then(() => {
        this.closeModal();
        this.cleanStates();
        this.showSnackbarSuccess(this.$t('sales.affiliates_program_saved'));
      });
    },
    getInfo() {
      this.getInfoProgram({ id: this.idProgramTemp });
    },
  },
  watch: {
    "$store.getters.affiliatesByProgram"() {
      this.turnSelectedAffiliatesIntoArray();
    },
    idProgramTemp() {
      if (this.dialogInsertAffiliate) {
        this.getInfo();
      } else {
        this.cleanStates();
      }
    },
  },
  beforeMount() {
    this.fetchAllAffiliates({
      loja: "",
      limite: 1000,
      pagina: 1,
      status: "",
      name: "",
    });
  },
};
</script>
